import React, { useEffect } from "react";
import { Checklist as UIChecklist } from "../../../components/ui";

/**
 * Payout timesheet checklist: requirements for payroll to confirm and submit.
 * Uses generic Checklist from ui with payout-timesheet-specific conditions.
 * Sets isSubmittable in parent when all requirements are met.
 */
const Checklist = ({
  workerTimesheet = false,
  hoursLog = false,
  hasConflicts = false,
  missingLogs = false,
  isEditing = false,
  isPayoutSigned = false,
  setIsSubmittable = () => {},
  maxJobsExceeded = false,
  className,
}) => {
  useEffect(() => {
    setIsSubmittable(
      workerTimesheet && hoursLog && !isEditing && isPayoutSigned && !maxJobsExceeded
    );
  }, [
    workerTimesheet,
    hoursLog,
    isEditing,
    isPayoutSigned,
    maxJobsExceeded,
    setIsSubmittable,
  ]);

  const conditions = [
    {
      met: !(hasConflicts && isEditing),
      message: "Hours Log and worker hours mismatch detected.",
    },
    {
      met: !(missingLogs && isEditing),
      message: "Hours logs not found for some shifts.",
    },
    {
      met: !isEditing,
      message: "Please finish editing and confirm the payout version.",
    },
    {
      met: isPayoutSigned || isEditing,
      message: "Please sign the payout timesheet.",
    },
    {
      met: !maxJobsExceeded,
      message:
        "Max jobs supported by the PDF format has been exceeded. Please use 5 or less unique jobs.",
    },
  ];

  return (
    <UIChecklist
      className={`${className} p-2 pb-0`}
      conditions={conditions}
      successMessage="All requirements met! You can now submit the timesheet."
    />
  );
};

export default Checklist;
